module.exports = __webpack_public_path__ + "img/hero.2146ed0f.png";